/* madeatdawn: fade text in/out as it enters/leaves the viewport.
   Pairs with madeatdawn-fade.css. Scoped to #MainContent so header,
   footer, drawers, and the announcement bar are never affected. */
document.addEventListener('DOMContentLoaded', () => {
  const prefersReducedMotion = window.matchMedia(
    '(prefers-reduced-motion: reduce)'
  ).matches;

  // Skip in the Shopify theme editor so sections never look half-faded
  const inDesignMode = window.Shopify && window.Shopify.designMode;

  if (prefersReducedMotion || inDesignMode || !('IntersectionObserver' in window)) {
    return;
  }

  const main = document.getElementById('MainContent');
  if (!main) return;

  const elements = main.querySelectorAll('h1, h2, h3, h4, h5, p, em');

  if (!elements.length) return;

  // Initial state: visible, but fade-capable
  elements.forEach(el => {
    el.classList.add('fade', 'fadeIn');
  });

  const observerOptions = {
    root: null,
    rootMargin: '100px',
    threshold: 0.6
  };

  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      const el = entry.target;

      // Ignore fade-out until JS is fully ready
      if (!el.classList.contains('fade-ready')) return;

      if (entry.isIntersecting) {
        el.classList.add('fadeIn');
        el.classList.remove('fadeOut');
      } else {
        el.classList.add('fadeOut');
        el.classList.remove('fadeIn');
      }
    });
  }, observerOptions);

  elements.forEach(el => observer.observe(el));

  // Allow fades AFTER observer setup
  requestAnimationFrame(() => {
    elements.forEach(el => el.classList.add('fade-ready'));
  });
});
